import { useState } from 'react'
import { customerApi } from '../../../services/api'

export default function Step4Customize({ onNext }) {
  const [primaryColor, setPrimaryColor] = useState('#6366f1')
  const [assistantName, setAssistantName] = useState('Assistant')
  const [saving, setSaving] = useState(false)

  const handleContinue = async () => {
    setSaving(true)
    try {
      await customerApi.put('/customer/widget-config', {
        appearance: { primaryColor },
        branding: { chatbotName: assistantName },
      })
    } catch (err) {
      console.error('Failed to save widget config:', err)
      // Continue anyway; user can update later
    } finally {
      setSaving(false)
    }
    onNext({ primaryColor, assistantName })
  }

  return (
    <div className="py-2">
      <h2 className="text-xl font-bold text-slate-900 mb-1">Make it yours</h2>
      <p className="text-slate-500 mb-6">
        Customize your assistant's appearance to match your brand.
      </p>

      <div className="space-y-5 mb-6">
        {/* Color picker */}
        <div>
          <label htmlFor="primary-color" className="block text-sm font-medium text-slate-700 mb-1">
            Primary color
          </label>
          <div className="flex items-center gap-3">
            <input
              id="primary-color"
              type="color"
              value={primaryColor}
              onChange={(e) => setPrimaryColor(e.target.value)}
              className="h-10 w-14 rounded-lg border border-slate-300 cursor-pointer p-0.5"
            />
            <input
              type="text"
              value={primaryColor}
              onChange={(e) => setPrimaryColor(e.target.value)}
              maxLength={7}
              className="w-28 px-3 py-2 border border-slate-300 rounded-lg text-sm text-slate-700 font-mono focus:outline-none focus:ring-2 focus:ring-indigo-500"
            />
          </div>
        </div>

        {/* Assistant name */}
        <div>
          <label htmlFor="assistant-name" className="block text-sm font-medium text-slate-700 mb-1">
            Assistant name
          </label>
          <input
            id="assistant-name"
            type="text"
            value={assistantName}
            onChange={(e) => setAssistantName(e.target.value.slice(0, 30))}
            placeholder="Assistant"
            maxLength={30}
            className="w-full px-4 py-2.5 border border-slate-300 rounded-xl text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
          />
          <p className="text-xs text-slate-400 mt-1">{assistantName.length}/30 characters</p>
        </div>
      </div>

      {/* Mini preview */}
      <div className="mb-6">
        <p className="text-sm font-medium text-slate-700 mb-2">Preview</p>
        <div className="border border-slate-200 rounded-xl overflow-hidden shadow-sm max-w-xs mx-auto">
          <div
            className="px-4 py-3 text-white font-semibold text-sm flex items-center gap-2"
            style={{ backgroundColor: primaryColor }}
          >
            <div className="h-7 w-7 rounded-full bg-white/20 flex items-center justify-center text-xs">
              {assistantName.charAt(0).toUpperCase()}
            </div>
            {assistantName || 'Assistant'}
          </div>
          <div className="bg-slate-50 p-4">
            <div className="bg-white rounded-xl rounded-bl-md px-3 py-2 text-sm text-slate-700 border border-slate-200 shadow-sm max-w-[80%]">
              Hi! How can I help you today?
            </div>
          </div>
        </div>
      </div>

      {/* Continue button */}
      <button
        onClick={handleContinue}
        disabled={saving}
        className="w-full px-8 py-3 bg-indigo-600 text-white font-semibold rounded-xl hover:bg-indigo-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
      >
        {saving ? (
          <>
            <div className="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
            Saving...
          </>
        ) : (
          'Continue'
        )}
      </button>

      <p className="text-xs text-slate-400 text-center mt-3">
        You can access full customization from Widget Settings anytime
      </p>
    </div>
  )
}
